import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=1815b094&scoped=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=1815b094&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815b094",
  null
  
)

export default component.exports